import React from 'react';

const Footer: React.FC = () => {
    return (
        <div className="footer-disclaimer">
            <div className="footer-content">
                <p>
                    המערכת הינה בגרסה ניסיונות ואינה מיועדת להחליף ייעוץ מקצועי, דיאגנוזה רפואית או טיפול. המידע המתקבל משימוש במערכת מתקבל ״כפי שהוא״ ללא כל אחריות או תמיכה ומפעילי המערכת ומפתחיה לא יהיו אחראיים לשום נזק ישיר או עקיף. השימוש במערכת יתבצע באחריות המשתמש בלבד. הנתונים מבוססים על ה-LIFE-CVD model. המודל פותח עבור מטופלים ללא היסטוריה של מחלה קרדיווסקולרית ידועה, שבץ, צנתורים, אי ספיקת כליות, פרפור פרוזדורים או אי-ספיקת לב.
                </p>
                <p className="footer-link">
                    <a 
                        href="/accessibility" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        הצהרת נגישות
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Footer;
